import  React from "react"
import { Skeleton } from "@mui/material"
import "./style.css"


const ChatListSkeleton = ({ itemCount = 7, embedded = false }) => {
  const rows = Array.from({ length: itemCount }).map((_, index) => (
        <div
          key={index}
          className="ChatUser-Container"
          style={
            embedded
              ? {
                  padding: "16px 24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  borderBottom: "1px solid #EEF2F6",
                  backgroundColor: "#fff",
                }
              : {
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f9f9f9",
                }
          }
        >
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            sx={{
              bgcolor: "rgba(0, 0, 0, 0.1)",
              flexShrink: 0,
            }}
          />

          <div className="Chat-User-Main" style={{ width: "100%" }}>
            <div
              className="Chat-User00"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginBottom: "4px",
              }}
            >
              <div className="Chat-User-Kathryn" style={{ display: "flex", alignItems: "center" }}>
                <Skeleton
                  variant="circular"
                  width={8}
                  height={8}
                  sx={{
                    mr: 1,
                    bgcolor: "rgba(0, 0, 0, 0.1)",
                  }}
                />

                <Skeleton variant="text" width={100} height={20} sx={{ bgcolor: "rgba(0, 0, 0, 0.1)" }} />
              </div>

              <Skeleton variant="text" width={60} height={16} sx={{ bgcolor: "rgba(0, 0, 0, 0.1)" }} />
            </div>

            <div
              className="Chat-User02"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginBottom: "4px",
              }}
            >
              <Skeleton variant="text" width="70%" height={16} sx={{ bgcolor: "rgba(0, 0, 0, 0.1)" }} />

              {/* {Math.random() > 0.6 && (
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  sx={{
                    bgcolor: "rgba(255, 0, 0, 0.1)",
                    ml: "auto",
                  }}
                />
              )} */}
            </div>

            <div
              className="Chat-User03"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Skeleton
                variant="rectangular"
                width={16}
                height={16}
                sx={{
                  borderRadius: "2px",
                  bgcolor: "rgba(0, 0, 0, 0.1)",
                }}
              />

              <Skeleton variant="text" width={60} height={14} sx={{ bgcolor: "rgba(0, 0, 0, 0.1)" }} />
            </div>
          </div>
        </div>
      ));

  if (embedded) {
    return (
      <div style={{ width: "100%", boxSizing: "border-box" }} role="status" aria-label="Loading chats">
        {rows}
      </div>
    );
  }

  return <div className="ChatUser-Main-Container">{rows}</div>;
};

export default ChatListSkeleton;



